export default "__VITE_ASSET__Xu2H3_W5__"